export enum AutoGroupCollections {
  INHERITED  = 'INHERITED',
  YES        = 'YES',
  NO         = 'NO',
}
